<div class="lightContent" appIframeTracker #previewFrame>
  <div class="headingPage">
    <h2 class="">Select Collections</h2>
  </div>

  <div class="wid50l">

    <div #colList class="app-page-listing" isPage="story" [isTemplateView]="true" [pageManager]="true"
      [mergeArticles]="elementsToExclude" pageId="template" allApi="all_elements" showSearch="true" getDragulaId="left"
      searchApi="search_elements" metaApi="element_meta" pageArticleApi="page_putArticle" [getZoneCollections]="tempArray"
      (sendSelectedCollection)="idSelectionChange($event)" [isTemplateFilled]="arrayList.length === limit" [design]="'template'" [isLimitExceeded]="arrayList.length >= limit">
    </div>

  </div>

  <div class="wid50r">
    <div class="selectCollBlock">
      <div class="fl">
        <div class="filledCount"> {{arrayList.length}}/{{limit}} </div>
        <div *ngIf="arrayList.length >= limit" class="filled">Filled</div>
      </div>
      <div class="fr">
        <button (click)="open_new('/dash/element/new?type=collection')">Create Collection</button>
      </div>
    </div>
    <div class='container relative fl100'>
      <ul class="selectedComponent">
        <div class='container' [dragula]="'another-bag'" [dragulaModel]='arrayList' style="min-height: 600px;"
          id="right">
          <ng-container *ngFor="let collection of arrayList;let i = index">
            <li value="collection.id">
              <div class="heading pin">
                <span class="number">{{i+1}}</span>
                <span [innerHTML]="htmlToPlaintext(collection.title)"></span>
              </div>
              <div class="status">
                <ul>
                  <li>
                    <!-- <span class="time">
                    {{collection.lastModifiedDate !== '-'?getNewTypeVersionDate(collection.lastModifiedDate):'-'}}
                  </span> -->
                  </li>
                  <li> <span class="format">{{collection.type}}</span> </li>
                </ul>
              </div>
              <span class="handle sortpara" style="position: absolute;top: 22px;right: 0px;"><i
                  class="icon-move"></i></span>
              <div style="position: absolute; top: 48px; right: -4px;">
                <span (click)="idSelectionChange(collection)"><i class="icon-close"></i></span>
              </div>
            </li>
          </ng-container>
        </div>
      </ul>
    </div>
  </div>
  <div class="right wid100">
    <button class="discard gray" name="discard" type="button" (click)="closePopup()">Close</button>
    <button class="save blue" name="save" type="button" (click)="finishSelection()">Done</button>
  </div>
  <div [class]="((matchPopup) ? 'lightBox embeddblock matchBlock block' : 'lightBox embeddblock matchBlock')"
*ngIf="matchPopup">
<app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfn($event)"
(sendMatchDetailsToParentfn) = getMatchDetailsToParentfn($event)
></app-match-component>
</div>
</div>
